var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 8.829,
    style: {},
    width: 8.829,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    d: "M4.366541752143427,7.328525259525885 c1.56988371719758,0 2.8499328171987317,-1.280049100001152 2.8499328171987317,-2.8499328171987317 C7.215829057945285,2.909354236526449 5.935779957944133,1.6293051365252982 4.366541752143427,1.6293051365252982 S1.5166089349446967,2.909354236526449 1.5166089349446967,4.479237953724029 C1.5166089349446967,6.048476159524734 2.7966580349458483,7.328525259525885 4.366541752143427,7.328525259525885 z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ffffff"
    },
    id: "svg_1",
    className: "selected"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.671982247c993969519bd6089d2a3ae7.svg";
export { ForwardRef as ReactComponent };